import React, {useContext, useEffect, useState} from 'react';
import {Layout, Menu} from 'antd';
import './index.css';
import {withRouter} from 'react-router-dom';
import {menuList} from '../configuration/config.json';
import {
	ApartmentOutlined,
	FileTextOutlined,
	FormOutlined,
	HomeOutlined,
	ScheduleOutlined,
	SoundOutlined,
	UserOutlined,
} from '@ant-design/icons';
import {sideMenuContext} from '../../router/IndexRouter';
import {checkPagePermission} from '../../views/sandbox/common/CheckUserPermission';

const {Sider} = Layout;
const {SubMenu} = Menu;

const iconList = {
	'/home': <HomeOutlined/>,
	'/party': <FileTextOutlined/>,
	'/society': <ApartmentOutlined/>,
	'/activity': <FormOutlined/>,
	'/base': <ScheduleOutlined/>,
	'/system': <SoundOutlined/>,
	'/private': <UserOutlined/>,
};

function SideMenu(props) {
	const [menu, setMenu] = useState([]);
	const [collapsed, setCollapsed] = useState(false);
	const [tipMenuList, setTipMenuList] = useState([]);
	const {sideMenu, setSideMenu, openKeys, setOpenKeys} = useContext(sideMenuContext);

	useEffect(() => {
		setMenu(menuList);
		// 刷新页面后，将当前所在页面的一级菜单展开，并默认选中当前 url 对应的二级菜单，由 selectKeys 控制
		const currentUrl = window.location.hash.replace('#', '');
		// 刷新页面后，默认显示当前页面对应的 Tab
		setSideMenu([defaultTab(menuList)]);
		setOpenKeys(['/' + currentUrl.split('/')[1]]);
	}, []);

	useEffect(() => {
		setTipMenuList(sideMenu);
	}, [sideMenu]);

	// 刷新页面后，找出高亮显示的菜单对应的 {key: xx, label: xx, role: xx} 对象，用于设置初始 Tab
	const defaultTab = (menuList) => {
		for (let menu of menuList) {
			if (menu.key === props.location.pathname) return menu;
			if (menu.children?.length > 0) {
				const result = defaultTab(menu.children);
				if (result) return result;
			}
		}
		return null;
	};

	const handleClick = (item) => {
		const upperMenu = menuList.filter(value => value.key === '/' + item.key.split('/')[1]);
		const moduleName = upperMenu ? upperMenu[0].label + ' -> ' : '';
		// 去重，避免页面上的 Tab 出现重复的内容。item 为 {key: xx, label: xx, role: xx}
		tipMenuList.push(item);
		setSideMenu([...new Set(tipMenuList)]);
		// 跳转到当前选中的页面
		props.history.push(item.key);
		// 将 currentPage 重置为 1
		sessionStorage.setItem('currentPage', '1');
		sessionStorage.setItem('moduleName', moduleName + item.label);
	};

	const renderMenu = (menuList) => {
		return menuList.map(item => {
			if (item.children?.length > 0 && checkPagePermission(item)) {
				// moduleName = item.label + " -> ";
				return (
					<SubMenu key={item.key} icon={iconList[item.key]} title={item.label}>
						{renderMenu(item.children)}
					</SubMenu>
				);
			}

			return checkPagePermission(item) &&
				<Menu.Item key={item.key} icon={iconList[item.key]} onClick={() => handleClick(item)}>
					{item.label}
				</Menu.Item>;
		});
	};

	// 默认 const selectKeys = [props.location.pathname] 即可。
	const getSelectedKey = (menuList) => {
		const localUrl = props.location.pathname;
		for (let menu of menuList) {
			if (menu.children?.length > 0) {
				for (let child of menu.children) {
					if (localUrl === child.key || (localUrl.includes(child.key) &&
						localUrl.replace(child.key, '').startsWith('/'))) return child.key;
				}
			} else {
				if (localUrl.includes(menu.key)) return menu.key;
			}
		}
		return localUrl;
	};

	// 当前选中的菜单项 key 数组
	const selectKeys = [getSelectedKey(menu)];

	// 当前选中的菜单项 key 数组
	// const selectKeys = [props.location.pathname];

	// 同时只展开一个一级菜单
	const onOpenChange = (keys) => {
		setOpenKeys([keys.pop()]); // 当只展开一个菜单时，只保留最后一个 key
	};

	return (
		// collapsed 控制左侧菜单是否折叠，默认不折叠
		<Sider collapsible collapsed={collapsed} onCollapse={value => setCollapsed(value)}
			   style={{backgroundColor: 'white'}}>
			<div style={{display: 'flex', height: '100%', 'flexDirection': 'column'}}>
				<div style={{flex: 1, 'overflow': 'auto'}}>
					<Menu theme="light"
						  mode="inline"
						  selectedKeys={selectKeys}     // 菜单高亮显示的 API
						  openKeys={openKeys}
						  onOpenChange={onOpenChange}   // 同时只展开一个一级菜单
						  triggerSubMenuAction="click"
					>
						{renderMenu(menu)}
					</Menu>
				</div>
			</div>
		</Sider>
	);
}

//  使用 export default withRouter() 将一个组件包裹起来后，该组件就可以访问到路由相关的属性，并且在路由发生变化时，也能够重新渲染组件。
//  这对于需要在组件中获取当前路由信息或者进行路由导航的情况非常有用。
export default withRouter(SideMenu);